import { useLocale } from '@/context/LocaleContext';

export function formatMessageTime(dateString: string, yesterdayLabel: string): string {
  if (!dateString) return '';

  const isoDate = dateString.replace(' ', 'T');
  const date = new Date(isoDate);
  if (Number.isNaN(date.getTime())) return dateString;

  const now = new Date();
  const diff = now.getTime() - date.getTime();
  const diffDays = Math.floor(diff / (1000 * 60 * 60 * 24));

  if (diffDays === 0) {
    return date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' });
  }
  if (diffDays === 1) return yesterdayLabel;
  if (diffDays < 0) {
    return date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' });
  }
  if (diffDays < 7) return `${diffDays}d`;
  return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
}

export function sortMessagesChronologically<T extends { id: number; created_at?: string }>(
  messages: T[],
): T[] {
  return [...messages].sort((a, b) => {
    if (a.id !== b.id) return a.id - b.id;
    return String(a.created_at ?? '').localeCompare(String(b.created_at ?? ''));
  });
}

export function useFormatMessageTime() {
  const { t } = useLocale();
  return (dateString: string) => formatMessageTime(dateString, t('messages_yesterday'));
}
